import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { ImageItemModel } from '../../model/image-item/image-item-model';

const HTML_TEMPLATE = `
<div class="container" *ngIf="images">
  <div (click)="callEdit(image._id, image.src)" *ngFor="let image of images; let i = index; let l = last" [ngClass]="{ 'mask-first' : i === 0, 'mask' : i != 0 && !l, 'mask-last' : l }" [style.background-image]="getBackground(image.src)">
    <p class="titulo-da-foto">
      {{image.title}}
    </p>
    <span class="data">
      {{dateAsString(image)}}
    </span>
    <ion-icon class="arrow-right" name="ios-arrow-forward" ></ion-icon>
  </div>
</div>
`;

const CSS_STYLE = `    
.mask {
	width: 140px;
	height: 105px;
	border-radius: 3px;
	background-size:cover;           
	display: inline-block; /*Display inline and maintain block characteristics.*/
	vertical-align: top; /*Makes sure all the divs are correctly aligned.*/
	white-space: normal; /*Prevents child elements from inheriting nowrap.*/
	margin-left: 16px;
}

.mask-first {
	width: 140px;
	height: 105px;
	border-radius: 3px;
	background-size:cover;           
	display: inline-block; /*Display inline and maintain block characteristics.*/
	vertical-align: top; /*Makes sure all the divs are correctly aligned.*/
	white-space: normal; /*Prevents child elements from inheriting nowrap.*/
	margin-left: 16px;
}

.mask-last {
	width: 140px;
	height: 105px;
	border-radius: 3px;
	background-size:cover;           
	display: inline-block; /*Display inline and maintain block characteristics.*/
	vertical-align: top; /*Makes sure all the divs are correctly aligned.*/
	white-space: normal; /*Prevents child elements from inheriting nowrap.*/
	margin-right: 24px;
	margin-left: 16px;
}

.titulo-da-foto {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	width: 120px;
	max-width: 120px;
	height: 23px;
	font-family: NunitoSans;
	font-size: 10px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.2;
	letter-spacing: normal;
	text-align: left;
	color: #ffffff;
	padding: 65px 12px 14px 8px;
}

.data {
	width: 109px;
	height: 16px;
	font-family: NunitoSans;
	font-size: 8px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	text-align: left;
	color: #ffffff;
	padding: 0px 65px 4.9px 8px;
}

.arrow-right {
	width: 8px;
	height: 13px;
	color: #ffffff;  
	float: right;
	margin-right: 10px;      
}      

.container
{
	white-space: nowrap; /*Prevents Wrapping*/
	

	overflow-x: scroll;
	overflow-y: hidden;
}

.container-photos{
	min-height: 105px;
}

p {
	margin-block-start: 0px;
	margin-block-end: 0px;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
  }
`;

@Component({
	selector: 'images-itens',
	template: HTML_TEMPLATE,
	styles: [CSS_STYLE],
	encapsulation: ViewEncapsulation.None
})
export class ImagesItensComponent {

	text: string;
	urlImage: string;

	@Input('callback') callback: Function;
	@Input('images') images: ImageItemModel[];

	constructor(private sanitizer: DomSanitizer) {
	}

	getBackground(image) {
		return this.sanitizer.bypassSecurityTrustStyle(`linear-gradient(to bottom, rgba(74, 92, 96, 0.2), rgba(29, 36, 38, 0.8)), url(${image})`);
	}

	callEdit(idImage) {
		this.callback(idImage);
	}

	dateAsString(image): string {
		return moment(image.date).format('L');
	}
}
